/* External */
import {
  memo,
  createContext,
  useEffect,
  useContext,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import minutesToMilliseconds from 'date-fns/minutesToMilliseconds';

/* Util */
import { useIsForegroundApp } from '../ForegroundAppProvider';

export const CurrentTimeContext = createContext(new Date());

export function useCurrentTime() {
  return useContext(CurrentTimeContext);
}

function CurrentTimeProvider({ children }) {
  const [currentTime, setCurrentTime] = useState(() => new Date());
  const isForegroundApp = useIsForegroundApp();

  useEffect(() => {
    let interval;
    let timeout;
    if (isForegroundApp) {
      const current = new Date();
      setCurrentTime(current);
      const milliSecondsLeft = 1000 - current.getMilliseconds();
      const secondsLeft = 60 - current.getSeconds();
      const milliSecondsTotalLeft = milliSecondsLeft + (secondsLeft * 1000);
      timeout = setTimeout(() => {
        interval = setInterval(() => {
          setCurrentTime(new Date());
        }, minutesToMilliseconds(1));
      }, milliSecondsTotalLeft);
    }
    return () => {
      if (timeout) clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, [isForegroundApp]);

  return (
    <CurrentTimeContext.Provider value={currentTime}>
      {children}
    </CurrentTimeContext.Provider>
  );
}

CurrentTimeProvider.defaultProps = {
  children: undefined,
};

CurrentTimeProvider.propTypes = {
  children: PropTypes.node,
};

export default memo(CurrentTimeProvider);
